import { Injectable } from '@angular/core';
import { globals } from '../globals';
import { HttpClient, HttpParams } from '@angular/common/http';
import { OcorrenciaHistorico } from '../models/ocorrencia-historico';

@Injectable({
  providedIn: 'root'
})
export class OcorrenciaHistoricoService {

  constructor(private http: HttpClient) { }

  consultarPorIdOcorrencia(idOcorrencia: number) {
    return this.http.get<any>(globals.apiUrl + '/api/OcorrenciaHistorico/BuscarPorIdOcorrencia',
      { params: new HttpParams().set('idOcorrencia', idOcorrencia.toString()) });
  }

  salvar(ocorrenciaHistorico: OcorrenciaHistorico) {
    return this.http.post(globals.apiUrl + '/api/OcorrenciaHistorico/Salvar', ocorrenciaHistorico);
  }

  ocultar(ocorrenciaHistorico: OcorrenciaHistorico) {
    ocorrenciaHistorico.ocultar = true;
    return this.http.post(globals.apiUrl + '/api/OcorrenciaHistorico/Salvar', ocorrenciaHistorico);
  }

  mostrar(ocorrenciaHistorico: OcorrenciaHistorico) {
    ocorrenciaHistorico.ocultar = false;
    return this.http.post(globals.apiUrl + '/api/OcorrenciaHistorico/Salvar', ocorrenciaHistorico);
  }
}
